import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7170c4cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-footer__business-hours" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "app-footer__title" }, " Stadtwerke Ahrensburg Kundenzentrum ", -1))
const _hoisted_3 = { class: "icon-row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, " Lohe 1, 22926 Ahrensburg ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("table", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", null, " Mo. & Do. "),
    /*#__PURE__*/_createElementVNode("td", null, " 09:00 - 18:00 Uhr ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", null, " Di. & Mi. "),
    /*#__PURE__*/_createElementVNode("td", null, " 09:00 - 13:00 Uhr ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", null, " Freitag "),
    /*#__PURE__*/_createElementVNode("td", null, " 09:00 - 12:00 Uhr ")
  ])
], -1))

import { library } from '@fortawesome/fontawesome-svg-core';
import { faLocationDot } from '@fortawesome/pro-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppFooterBusinessHours',
  setup(__props) {

library.add(faLocationDot);

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createVNode(_component_FontAwesomeIcon, { icon: _unref(faLocationDot) }, null, 8, ["icon"])
      ]),
      _hoisted_4
    ]),
    _hoisted_5
  ]))
}
}

})